import { useAppSelector } from 'redux/hooks';
import { authSelectors } from 'redux/modules/Authorization';

export const useCurrentRole = () => useAppSelector(authSelectors.getUserRole);
